
/**
 * コンポーネントが指定した prop を必要としているか判定する
 *  - (props: [propName] または { [propName]: {...} } の宣言で判断)
 * @param {object} vueOption
 * @param {string} propName
 * @returns {boolean}
 */
export function needsProp (vueOption, propName) {
  return Array.isArray(vueOption.props)
    ? vueOption.props.includes(propName)
    : Boolean(vueOption.props?.[propName])
}
